import { $http } from "./fetch";

/**
 * 注册会员
 */
const feedback = (data) => {
  return Promise.resolve(
    $http({
      url: "/Opinion/insertOpinion",
      params: data
    })
  );
};


export default {
    feedback
};
